const directiveName = 'ltValidatePhoneNumber';
const directive = [() => {

	function isValid(phoneText: string): boolean {
		let valid = !!phoneText && phoneText.length === 10;
		valid = valid && phoneText.substring(0, 1) !== '0';
		valid = valid && phoneText.substring(3, 4) !== '0';

		return valid;
	}

	return {
		require: 'ngModel',
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl: ng.INgModelController) => {

			ctrl.$validators.invalidPhoneNumber = (modelValue: string, viewValue: string) => {
				return isValid(modelValue);
			};

		}
	} as ng.IDirective<ng.IScope, ng.IAugmentedJQuery, ng.IAttributes, ng.INgModelController>;
}];

export default function(module: ng.IModule): void {
	module.directive(directiveName, directive);
}
